import React from 'react';
import LazyImage from '../lazy-image';
import { getFluidGatsbyImage } from '../../utils/gatsby-storyblok-image-fixed';
import CtaWithArrow from '../cta-with-arrow';
import styled, { css } from 'styled-components';
import mq from '../../utils/mq';
import { Link } from 'gatsby';

const CardItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  height: 100%;
  gap: 16px;
`;

const ImageContainer = styled.div`
  flex-shrink: 0;
  width: 100%;
  overflow: hidden;
  position: relative;
  aspect-ratio: 16 / 10;
  border-radius: var(--Radius-Radius-3, 16px);
  overflow: hidden;
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  height: 100%;
`;

const Title = styled.h2`
  color: #161616;
  font-size: 27px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
  letter-spacing: -0.54px;
  margin-bottom: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
`;

const Description = styled.p`
  color: #666;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 160%;
  letter-spacing: -0.32px;
  margin-bottom: 20px;
  height: 77px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  ${mq.mobile(css`
    max-height: 77px;
    overflow: hidden;
    height: fit-content;
  `)};
`;

const Tags = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 32px;
  ${mq.mobile(css`
    margin-bottom: 24px;
  `)};
`;

const Tag = styled.div`
  color: #161616;
  leading-trim: both;
  text-edge: cap;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  letter-spacing: 0.28px;
  border-radius: 5px;
  background: #f3f3f3;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px;
`;

export default function CaseStudyProjectGridCardItem({
  caseStudy
}: {
  caseStudy: any;
}) {
  console.log(caseStudy);
  return (
    <CardItemContainer>
      <Link
        to={caseStudy.to}
        style={{ width: '100%', height: '100%', cursor: 'pointer' }}
      >
        <ImageContainer>
          <LazyImage
            fluid={
              caseStudy?.image
                ? caseStudy?.image
                : getFluidGatsbyImage(caseStudy?.content?.gridImage)
            }
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            width="100%"
            height="100%"
          />
        </ImageContainer>
      </Link>
      <ContentContainer>
        <Title>{caseStudy?.content?.title}</Title>
        <Description>{caseStudy?.content?.about[0].infoParagraph}</Description>
        {caseStudy?.content?.projectTags?.value &&
          caseStudy?.content?.projectTags?.value?.length > 0 && (
            <Tags>
              {caseStudy?.content?.projectTags?.value?.map(
                (tag: any, i: number) => (
                  <Tag key={i}>{tag}</Tag>
                )
              )}
            </Tags>
          )}
        <CtaWithArrow
          label="View Case Study"
          link={`/${caseStudy?.full_slug}`}
        />
      </ContentContainer>
    </CardItemContainer>
  );
}
